import type {GetDigitalAssetCollectionsParamsADto} from '@cohort/admin-schemas/digitalAssetCollection';
import type {PaginationFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import {useBasePageFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import {getDigitalAssetsRoute} from '@cohort/merchants/lib/Pages';

export const statusFilter = ['ready', 'live'] as const;
export const sortFilter = ['updatedAt', 'internalName'] as const;

type DigitalAssetCollectionsListFilters = {
  status: GetDigitalAssetCollectionsParamsADto['status'];
  setStatus: (status: GetDigitalAssetCollectionsParamsADto['status']) => void;
  sort: GetDigitalAssetCollectionsParamsADto['orderBy'];
  setSort: (sort: GetDigitalAssetCollectionsParamsADto['orderBy']) => void;
  reset: () => void;
};

export const useDigitalAssetCollectionsListFilters = (): PaginationFilters &
  DigitalAssetCollectionsListFilters =>
  useBasePageFilters<DigitalAssetCollectionsListFilters>(getDigitalAssetsRoute().path, set => ({
    status: undefined,
    setStatus: status => set({status}),
    sort: 'updatedAt',
    setSort: sort => set({sort}),
    reset: () =>
      set({
        status: undefined,
        sort: 'updatedAt',
      }),
  }));
